import axios from 'axios';

// Single axios wrapper for the subscription system (Features 1–9, 11).
// Reuses the existing global axios instance (baseURL + Bearer token from main.js).
export const subscriptionService = {
  // ── Storefront (public) ──
  async academicYears() {
    const res = await axios.get('/academic-years/subscribable');
    return res.data.data || [];
  },
  async academicYear(id) {
    const res = await axios.get(`/academic-years/${id}`);
    return res.data.data;
  },
  // Academic-Year subscription context: returns the FULL response body
  // ({ status, message?, data }) so the subscribe page can surface clean
  // business messages (year not found / no plans configured) itself.
  async academicYearPlans(id) {
    const res = await axios.get(`/academic-years/${id}/subscription-plans`);
    return res.data;
  },
  async homeAcademicYears() {
    const res = await axios.get('/academic-years/home');
    return res.data.data || [];
  },
  async courses() {
    const res = await axios.get('/courses/subscribable');
    return res.data.data || [];
  },
  async homeCourses() {
    const res = await axios.get('/courses/home');
    return res.data.data || [];
  },
  async course(id) {
    const res = await axios.get(`/courses/${id}`);
    return res.data.data;
  },
  async paymentMethods() {
    const res = await axios.get('/payment-methods/active');
    return res.data.data || [];
  },
  // Course/academic-year scoped exam list (Course Content Mode). Mirrors the
  // params currentExam.vue already sends to the same endpoint.
  async examsWeb(params) {
    const res = await axios.get('/exams_web', { params });
    return res.data.data || [];
  },

  // ── Student flow (auth) ──
  async subscribe({ type, subscribable_id, plan_type }) {
    const res = await axios.post('/subscriptions/subscribe', { type, subscribable_id, plan_type });
    return res.data.data; // { subscription, payment_methods }
  },
  // payload is FormData (receipt image + fields)
  async uploadReceipt(formData) {
    const res = await axios.post('/subscriptions/upload-receipt', formData);
    return res.data.data;
  },
  async mySubscriptions() {
    const res = await axios.get('/subscriptions/mine');
    return res.data.data || [];
  },
  async paymentHistory() {
    const res = await axios.get('/subscriptions/payment-history');
    return res.data.data || [];
  },
  async renew({ subscription_id, plan_type }) {
    const res = await axios.post('/subscriptions/renew', { subscription_id, plan_type });
    return res.data.data; // { subscription, payment_methods }
  },

  // ── Notifications (auth) ──
  async notifications() {
    const res = await axios.get('/notifications');
    return res.data; // { unread_count, data }
  },
  async markNotificationsRead() {
    const res = await axios.post('/notifications/read');
    return res.data;
  },
  async markNotificationRead(id) {
    const res = await axios.post(`/notifications/${id}/read`);
    return res.data;
  },
};
